import {Type} from './types/Type';

export class InputType {

    target: HTMLElement;
    eNormolizer: Type;

    constructor(eNormolizer: Type) {
        this.eNormolizer = eNormolizer;
    }

    public setTarget(target: HTMLElement) {
        this.target = target;
    }

    public execute(): void {
        this.eNormolizer.setTarget(this.target);
        this.eNormolizer.execute();
    }
}
